import { applyMiddleware, combineReducers, createStore, compose } from 'redux';
import thunk from 'redux-thunk';
import { APIReducer } from 'store/apiReducer';
import compte from './compte/index';
import referentiel from './referentiel/index';
import recherche from './recherche';
import profil from './profil';
import armes from './armes';
import adresseVerificationBAN from './adresseVerificationBAN';
import notification from './notification';
import alertesMiddleware from './alertes/alertesMiddleware';
import alertes from './alertes';
import etapes from './etapes';
import monCompte from './mon-compte';
import fichier from './fichier';
import materiel from './materiel';
import mesDeclarationsArmes from './mesDeclarationsArmes';
import contact from './contact';
import repriseDeDonnees from './repriseDeDonnees';
import adresseExtensions from './adresseExtensions';
import { CLEAR_ALERTES, CLEAR_INFORMATIONS } from '../utils/utils';
import ceaf from './ceaf/index';
import carteCollectionneur from './carteCollectionneur/index';
import {
    CONTEXT_GET_FEATURE_FLIPPING,
    CONTEXT_GET_ENTREPRISE_SIREN,
    CONTEXT_GET_ENTREPRISE_SIRET,
    CONTEXT_GET_ASSOCIATION_RNA,
} from '../constants/apiUrls.constants';
import documentUtilisateur from './documentUtilisateur';
import deconnexionMiddleware from './deconnexion/deconnexionMiddleware';
import titreDetention from './titreDetention';
import mesDemarchesEtAutorisations from './demarchesEtAutorisation';
import historique from './historique';
import { titreReducer } from './titreReducer';
import sirenReducer from './entrepriseReducer';
import rnaReducer from './associationReducer';
import gestionEmployes from './employes';
import transferts from './transferts';

// Combine all reducers.
const appReducer = combineReducers({
    /** Import des stores */
    compte,
    referentiel,
    recherche,
    historique,
    profil,
    armes,
    adresseVerificationBAN,
    notification,
    alertes,
    etapes,
    monCompte,
    fichier,
    gestionEmployes,
    materiel,
    mesDemarchesEtAutorisations,
    mesDeclarationsArmes,
    contact,
    repriseDeDonnees,
    adresseExtensions,
    ceaf,
    carteCollectionneur,
    featureFlipping: APIReducer.bind(null, CONTEXT_GET_FEATURE_FLIPPING),
    documentUtilisateur,
    titreDetention,
    transferts,
    titre: titreReducer,
    entreprise: combineReducers({
        siren: sirenReducer(CONTEXT_GET_ENTREPRISE_SIREN),
        siret: sirenReducer(CONTEXT_GET_ENTREPRISE_SIRET),
    }),
    association: combineReducers({
        rna: rnaReducer(CONTEXT_GET_ASSOCIATION_RNA),
    }),
});

const rootReducer = (state, action) => {
    switch (action.type) {
        // Clear all data in redux store to initial.
        case CLEAR_INFORMATIONS:
            // eslint-disable-next-line no-param-reassign
            state = undefined;
            break;
        case CLEAR_ALERTES:
            // eslint-disable-next-line no-param-reassign
            state.alertes.alertes = [];
            break;
        default:
            break;
    }

    return appReducer(state, action);
};

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(
    rootReducer,
    composeEnhancer(applyMiddleware(thunk, alertesMiddleware, deconnexionMiddleware)),
);
